import axios from 'axios';

// Orderbook Aggregator - normalized orderbooks
export const orderBookAxiosApi = axios.create({
  baseURL: import.meta.env.VITE_ORDERBOOK_AGGREGATOR_URL
});

// Profits WebSocket - HTTP endpoints
export const profitsWsAxiosApi = axios.create({
  baseURL: import.meta.env.VITE_PROFITS_WS_URL
});

// Crypto State Manager - read-cryptos & modified-cryptos
export const cryptoStateAxiosApi = axios.create({
  baseURL: import.meta.env.VITE_CRYPTO_STATE_URL
});

// Arbitrage Calculator (Rust) - calculation stats
export const calculatorAxiosApi = axios.create({
  baseURL: import.meta.env.VITE_CALCULATOR_URL
});

// Prediction Manager - pair CRUD, matching, and system on/off
export const predictionManagerAxiosApi = axios.create({
  baseURL:
    import.meta.env.VITE_PREDICTION_MANAGER_URL ||
    import.meta.env.VITE_PREDICTION_PAIR_MANAGER_URL
});

// Prediction Calculator - arbitrage calculations for prediction markets
export const predictionCalculatorAxiosApi = axios.create({
  baseURL: import.meta.env.VITE_PREDICTION_CALCULATOR_URL
});

// Prediction WebSocket - real-time prediction opportunities
export const predictionWsAxiosApi = axios.create({
  baseURL: import.meta.env.VITE_PREDICTIONS_WS_URL
});

// Prediction Arbitrage Manager - positions and trade execution
export const predictionArbitrageManagerAxiosApi = axios.create({
  baseURL: import.meta.env.VITE_PREDICTION_ARBITRAGE_MANAGER_URL
});

// Position Unwinder - unwinding rules/executions API
export const positionUnwinderAxiosApi = axios.create({
  baseURL: import.meta.env.VITE_POSITION_UNWINDER_URL + '/api/position-unwinder'
});

// Add auth interceptor to all instances
[
  orderBookAxiosApi,
  profitsWsAxiosApi,
  cryptoStateAxiosApi,
  calculatorAxiosApi,
  predictionManagerAxiosApi,
  predictionCalculatorAxiosApi,
  predictionWsAxiosApi,
  predictionArbitrageManagerAxiosApi,
  positionUnwinderAxiosApi
].forEach(api =>
  api.interceptors.request.use(
    async config => {
      const token = _getToken();
      if (token) {
        config.headers = {
          ...config.headers,
          authorization: `Bearer ${token}`,
          Accept: 'application/json'
        };
      }
      return config;
    },
    error => Promise.reject(error)
  )
);

export function _getToken(): string {
  return localStorage.getItem(import.meta.env.VITE_AUTH_TOKEN_KEY!) || '';
}
